import { API } from 'aws-amplify'

export const getDisconnectionCount = (month) => {
    return API.get('baseURL', `/ae/disconnections/count?month=${month}`)

}